module.exports = __webpack_public_path__ + "4809fc8e7881de9be7cb27c025759d5a.MP3";